import { PageInfo, TableFetchData } from "@powerledger/ui-component-lib";
import { Dispatch, SetStateAction } from "react";
import { Column } from "react-table";

import { ApplyFiltersFn } from "@/app/components/page-header/filter/filter.types";
import { CertificationAndEliglibilityType } from "@/app/lib/format-attributes";
import { RECOrderAttributeOptions } from "@/app/lib/format-rec-options";
import {
  Account,
  MatchedTrade,
  Maybe,
  RecAttributes,
  SimpleAccount,
  TradeContract,
  TradeContractStatus,
} from "@/app/types/generated/graphql";
import { AggregatedRegistryCode } from "@/app/types/okta.types";

export type PartialAccountInfo = {
  __typename: "Account";
  id: Account["id"];
  company?: Maybe<Pick<NonNullable<Account["company"]>, "businessName" | "id">>;
};

export type TradeContractHistoryTableData = Omit<
  TradeContract,
  "attributes" | "account" | "counterAccount" | "matchedTrade"
> & {
  attributes: RecAttributes;
  formattedAttributes: RecAttributes & { certificationsAndEligibilities: CertificationAndEliglibilityType[] };
  account: PartialAccountInfo;
  counterAccount?: SimpleAccount;
  matchedTrade?: Maybe<Omit<MatchedTrade, "tradeContractChangeRequests">>;
};

export type ForwardTradeHistoryViewProps = {
  forwardTradeEnabled: boolean;
  tableData: TradeContractHistoryTableData[];
  loading: boolean;
  fetchData: TableFetchData<TradeContractHistoryTableData>;
  pageInfo: PageInfo;
  reloadTradeContractHistory: () => void;
  tableColumns: Column<TradeContractHistoryTableData>[];
  showAllAttributes: boolean;
  setShowAllAttributes: Dispatch<SetStateAction<boolean>>;
  recOptions?: RECOrderAttributeOptions;
  handleFilterChange: ApplyFiltersFn;
  activeRegistryCode?: AggregatedRegistryCode;
  setActiveRegistryCode: Dispatch<SetStateAction<AggregatedRegistryCode>>;
  enableCrossRegistryForwardTrading: boolean;
};

export type UseForwardTradeHistoryFn = () => ForwardTradeHistoryViewProps;

export type AssignRecsProps = {
  tradeContractNumber: string;
  tradeContractRegistryCode: AggregatedRegistryCode;
  tradeContractId: string;
  askTradeVolume: number;
  tradeAttributes: RecAttributes;
  status: TradeContractStatus;
  assetAssignmentStatus: TradeContract["assetAssignmentStatus"];
};

export const PreAgreementStatuses = [
  TradeContractStatus.Open,
  TradeContractStatus.Pending,
  TradeContractStatus.PendingReview,
];
